import { render } from "./MobileBar.vue?vue&type=template&id=06d8b10f&scoped=true&ts=true"
import script from "./MobileBar.vue?vue&type=script&lang=ts"
export * from "./MobileBar.vue?vue&type=script&lang=ts"

import "./MobileBar.vue?vue&type=style&index=0&id=06d8b10f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06d8b10f"]])

export default __exports__